import { getBrandConfig, phoneCodesByOrder, paymentUrls, apiEndpointMappings, currencyFormats } from '../brand/brand.config.js';

export function useBrand() {
  function detectBrand() {
    // Check URL parameters first
    const urlParams = new URLSearchParams(window.location.search);
    const brandParam = urlParams.get('brand');
    if (brandParam) {
      return brandParam.toUpperCase();
    }

    // Check domain-based detection
    const hostname = window.location.hostname;
    const domainMappings = {
      'lax': 'LAX',
      'rdu': 'RDU', 
      'her': 'HER',
      'yhm': 'YHM',
      'pit': 'PIT',
      'rsw': 'RSW',
      'pv1': 'PV1',
      'sv1': 'SV1',
      'noc': 'NOC',
      'nqy': 'NQY',
      'nwi': 'NWI',
      'ldy': 'LDY',
      'ml1': 'ML1',
      'szg': 'SZG',
      'fm1': 'FM1',
      'fmm': 'FMM',
      'pb1': 'PB1',
      'drw': 'DRW'
    };
    
    for (const [domain, brand] of Object.entries(domainMappings)) {
      if (hostname.includes(domain)) return brand;
    }
    
    // Check for LAXNew specific indicators
    const path = window.location.pathname;
    if (path.includes('laxnew') || urlParams.get('version') === 'new') {
      return 'LAXNEW';
    }

    // Default fallback
    return 'DEFAULT';
  }

  function getCurrentBrand() {
    return detectBrand();
  }

  function getBrandConfiguration() {
    const brandCode = getCurrentBrand();
    const config = getBrandConfig(brandCode);
    
    // Enhance config with computed properties
    return {
      ...config,
      brandCode,
      phoneCodes: phoneCodesByOrder[config.phoneCodeOrder] || phoneCodesByOrder.UK_FIRST,
      paymentUrl: paymentUrls[config.paymentProvider],
      apiEndpoint: apiEndpointMappings[config.apiEndpoints],
      currencyFormat: currencyFormats[config.currency]
    };
  }

  function getPhoneCodesForBrand(brandCode) {
    const config = getBrandConfig(brandCode);
    return phoneCodesByOrder[config.phoneCodeOrder] || phoneCodesByOrder.UK_FIRST;
  }

  function getPaymentUrlForBrand(brandCode) {
    const config = getBrandConfig(brandCode);
    return paymentUrls[config.paymentProvider];
  }

  return {
    detectBrand,
    getCurrentBrand,
    getBrandConfiguration,
    getPhoneCodesForBrand,
    getPaymentUrlForBrand
  };
}